import React from 'react';
import ReactDOM from 'react-dom';
import {
  AppContextProvider,
  MapContextProvider,
  OverlayContextProvider,
  ActiveHexContextProvider,
} from 'shared/context';
import { GlobalStyle } from 'shared/styles';
import App from 'pages/App';

import 'leaflet/dist/leaflet.css';
import 'index.css';

ReactDOM.render(
  <React.StrictMode>
    <AppContextProvider>
      <MapContextProvider>
        <OverlayContextProvider>
          <ActiveHexContextProvider>
            <GlobalStyle />
            <App />
          </ActiveHexContextProvider>
        </OverlayContextProvider>
      </MapContextProvider>
    </AppContextProvider>
  </React.StrictMode>,
  document.getElementById('root'),
);
